import { useEffect, useState } from "react";
import {
  fetchBaasPlatformCountries,
  getFallbackCountryOptions,
} from "../Services/baasPlatformOptionsApi";

export const useBaasCountryOptions = (instance) => {
  const [countryOptions, setCountryOptions] = useState(getFallbackCountryOptions);
  const [loadingCountries, setLoadingCountries] = useState(false);

  useEffect(() => {
    if (!instance) {
      setCountryOptions(getFallbackCountryOptions());
      return undefined;
    }

    const controller = new AbortController();
    setLoadingCountries(true);

    fetchBaasPlatformCountries(instance, { signal: controller.signal })
      .then((options) => {
        if (!controller.signal.aborted) {
          setCountryOptions(options);
        }
      })
      .catch(() => {
        if (!controller.signal.aborted) {
          setCountryOptions(getFallbackCountryOptions());
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setLoadingCountries(false);
        }
      });

    return () => controller.abort();
  }, [instance?.id, instance?.baasInstanceId, instance?.environment]);

  return { countryOptions, loadingCountries };
};
